import React from 'react'
import EmptySearchImage from 'images/search_icon.svg'

import './style.css'

const EmptySearchResults = () => {
  return (
    <div className='empty-search-container'>
      <img src={EmptySearchImage} alt='Search Icon'/>
      <h2 className="empty-search-primary-text">No Results Found</h2>
      <p className='empty-search-secondary-text'>
        We couldn’t find any articles that matched your search term.
        Refine your search we’ll see if we can find what you’re looking for.
      </p>
    </div>
  )
}

export default EmptySearchResults